/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleContext } from './moduleContext';

export type UserContextInputCurrentModule = ModuleContext | null;
